module.exports = __webpack_public_path__ + "img/skyline3.540f9bdc.jpg";